import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getStockValueReport } from '@/api/reports';
import { BranchAgentService } from '@/services/branch-agent-service';
import { exportJson2Excel } from '@/utils/excel';
import { getQuery, formatJson } from '@/utils/index';
import { searchProducts } from '@/api/products';
import { getRanges } from '@/api/ranges';
import { getCategories } from '@/api/categories';
import Pagination from '@/components/Pagination/index.vue';
let StockValueReport = class StockValueReport extends Vue {
  constructor() {
    super(...arguments);
    this.branchId = null;
    this.branchList = [];
    this.branchListLoading = false;
    this.reportData = [];
    this.listLoading = false;
    this.showFilters = false;
    // Drill-down navigation state
    this.currentView = 'branches';
    this.selectedBranch = null;
    this.selectedUnit = null;
    this.selectedProductRow = null;
    // Lazy-loaded sublists
    this.unitsList = [];
    this.productsList = [];
    // Product filter (remotely loaded list & selected value)
    this.selectedProduct = null;
    this.products = [];
    this.productListLoading = false;
    // Range and category filters
    this.rangeList = [];
    this.categoryList = [];
    this.subCategoryList = [];
    this.selectedRangeId = null;
    this.selectedCategoryId = null;
    this.selectedSubCategoryId = null;
    // Pagination & Sort state for the currently active products list view
    this.listQuery = {
      page: 1,
      limit: 10
    };
    this.unitSort = null;
    this.assignedBranches = null;
    // For a Zonal Manager, Branch Manager or Agent: strictly the
    // admins_branches/agents_branches mapping, not the broader branchIds
    // every other role uses. null = not applicable (no override); [] = an
    // admin/agent with nothing explicitly mapped (must show zero branches,
    // not "no filter").
    this.explicitAdminBranches = null;
  }
  async created() {
    var _await$BranchAgentSer;
    this.assignedBranches = await BranchAgentService.assignBranchId();
    this.explicitAdminBranches = (_await$BranchAgentSer = await BranchAgentService.resolveExplicitAdminBranches()) !== null && _await$BranchAgentSer !== void 0 ? _await$BranchAgentSer : await BranchAgentService.resolveExplicitAgentBranches();
    if (this.explicitAdminBranches !== null) {
      this.branchList = this.explicitAdminBranches.length ? await BranchAgentService.fetchBranches(this.explicitAdminBranches) : [];
    } else {
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    }
    this.fetchData();
    this.fetchRanges();
  }
  formatNumber(n) {
    if (!n && n !== 0) return '0.00';
    return Number(n).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  getFilterParams() {
    const params = {};
    if (this.selectedRangeId) params.rangeId = this.selectedRangeId;
    if (this.selectedCategoryId) params.categoryId = this.selectedCategoryId;
    if (this.selectedSubCategoryId) params.subCategoryId = this.selectedSubCategoryId;
    return params;
  }
  // Load branches (or units directly if branchId select dropdown is used)
  async fetchData() {
    this.listLoading = true;
    try {
      // Zonal Manager / Branch Manager with nothing in admins_branches:
      // show zero branches, not "no filter" (an empty assignedBranches
      // param would be dropped by the backend and return every branch,
      // which is exactly what we must avoid here).
      if (this.explicitAdminBranches !== null && this.explicitAdminBranches.length === 0) {
        this.reportData = [];
        this.listLoading = false;
        return;
      }
      const params = {
        ...this.getFilterParams()
      };
      if (this.branchId) {
        params.branchId = this.branchId;
      } else if (this.explicitAdminBranches !== null) {
        params.assignedBranches = this.explicitAdminBranches.join(',');
      } else if (this.assignedBranches) {
        params.assignedBranches = Array.isArray(this.assignedBranches) ? this.assignedBranches.join(',') : this.assignedBranches;
      }
      const res = await getStockValueReport(params);
      console.log('stock-value-report params sent:', params);
      console.log('stock-value-report response res:', res);
      if (this.branchId) {
        const matchingBranch = this.branchList.find(b => b.id === this.branchId);
        this.selectedBranch = {
          branchId: this.branchId,
          branch: matchingBranch ? matchingBranch.name : 'Selected Branch',
          branchCode: matchingBranch ? matchingBranch.code : '',
          branchTotalValue: 0
        };
        this.unitsList = res || [];
        this.selectedBranch.branchTotalValue = this.unitsList.reduce((acc, u) => acc + (u.unitTotalValue || 0), 0);
        this.currentView = 'units';
        this.selectedUnit = null;
        this.selectedProduct = null;
        this.products = [];
      } else {
        this.reportData = res || [];
        this.currentView = 'branches';
        this.selectedBranch = null;
        this.selectedUnit = null;
        this.unitsList = [];
        this.productsList = [];
        this.selectedProduct = null;
        this.products = [];
      }
    } catch (err) {
      this.$message.error('Error fetching stock data');
    } finally {
      this.listLoading = false;
    }
  }
  async selectBranch(row) {
    this.listLoading = true;
    try {
      this.selectedBranch = row;
      this.selectedUnit = null;
      this.selectedProduct = null;
      this.products = [];
      const params = {
        branchId: row.branchId,
        ...this.getFilterParams()
      };
      const res = await getStockValueReport(params);
      this.unitsList = res || [];
      this.selectedBranch.branchTotalValue = this.unitsList.reduce((acc, u) => acc + (u.unitTotalValue || 0), 0);
      this.currentView = 'units';
    } catch (err) {
      this.$message.error('Error fetching units');
    } finally {
      this.listLoading = false;
    }
  }
  async selectUnit(row) {
    this.listLoading = true;
    try {
      this.selectedUnit = row;
      this.selectedProduct = null;
      this.products = [];
      const params = {
        unitId: row.unitId,
        ...this.getFilterParams()
      };
      const res = await getStockValueReport(params);
      this.productsList = res || [];
      this.currentView = 'products';
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.unitSort = null;
    } catch (err) {
      this.$message.error('Error fetching products');
    } finally {
      this.listLoading = false;
    }
  }
  navigateTo(view) {
    this.currentView = view;
    this.selectedProduct = null;
    this.products = [];
    this.selectedProductRow = null;
    if (view === 'branches') {
      this.selectedBranch = null;
      this.selectedUnit = null;
      this.unitsList = [];
      this.productsList = [];
      this.branchId = null;
      this.fetchData();
    } else if (view === 'units') {
      this.selectedUnit = null;
      this.productsList = [];
    }
  }
  goBack() {
    this.selectedProduct = null;
    this.products = [];
    if (this.currentView === 'products') {
      this.currentView = 'units';
      this.selectedUnit = null;
      this.productsList = [];
    } else if (this.currentView === 'units') {
      this.navigateTo('branches');
    }
  }
  get filteredProducts() {
    let products = [...this.productsList];
    if (this.selectedProduct) {
      if (this.selectedProduct.startsWith('product-')) {
        const id = Number(this.selectedProduct.replace('product-', ''));
        products = products.filter(p => p.productId === id);
      } else if (this.selectedProduct.startsWith('variation-')) {
        const id = Number(this.selectedProduct.replace('variation-', ''));
        products = products.filter(p => p.productsVariationId === id);
      }
    }
    return products;
  }
  get total() {
    return this.filteredProducts.length;
  }
  getList() {
    // Client-side pagination handler. Slicing in getUnitProducts automatically updates because listQuery page/limit are reactive.
  }
  async getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        const res = await searchProducts(getQuery({
          keyword: query
        }));
        this.products = res || [];
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  flexColumnWidth(prop, label, minWidth = 80) {
    let list = [];
    // Choose appropriate list based on properties
    if (['branch', 'branchCode', 'branchTotalValue'].includes(prop)) {
      list = this.reportData;
    } else if (['unit', 'unitTotalValue', 'unitType'].includes(prop)) {
      list = this.unitsList;
    } else if (['productName', 'variationName', 'stock', 'mrp', 'discountType', 'rate', 'value'].includes(prop)) {
      list = this.productsList;
    }
    let maxLen = label.length;
    for (const item of list) {
      let val = item[prop];
      if (val === null || val === undefined) {
        val = '';
      }
      if (['branchTotalValue', 'unitTotalValue', 'value', 'rate', 'mrp'].includes(prop)) {
        val = '₹ ' + this.formatNumber(Number(val));
      } else if (prop === 'discountType') {
        if (item.discountType === 'nett') {
          val = `Nett: ₹${this.formatNumber(item.nettDiscount)}`;
        } else if (item.discountType === 'percent') {
          val = `Percent: ${item.percentDiscount}%`;
        } else {
          val = 'No policy';
        }
      }
      const len = String(val).length;
      if (len > maxLen) {
        maxLen = len;
      }
    }
    // Multiply by average character width (e.g., 9px) and add padding (e.g., 30px)
    const calculatedWidth = maxLen * 9 + 30;
    return `${Math.max(calculatedWidth, minWidth)}px`;
  }
  getUnitProducts() {
    const products = [...this.filteredProducts];
    if (this.unitSort && this.unitSort.order) {
      const isAsc = this.unitSort.order === 'ascending';
      const prop = this.unitSort.prop;
      products.sort((a, b) => {
        const valA = a[prop];
        const valB = b[prop];
        if (typeof valA === 'number' && typeof valB === 'number') {
          return isAsc ? valA - valB : valB - valA;
        }
        return isAsc ? String(valA).localeCompare(String(valB)) : String(valB).localeCompare(String(valA));
      });
    }
    // Paginate sliced products
    const page = this.listQuery.page;
    const limit = this.listQuery.limit;
    return products.slice((page - 1) * limit, page * limit);
  }
  handleUnitSortChange(sortData) {
    const {
      prop,
      order
    } = sortData;
    this.unitSort = {
      prop,
      order
    };
    this.listQuery.page = 1;
  }
  // Summaries
  getBranchSummary(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.property === 'branchTotalValue' || column.property === 'branchTotal90PlusValue') {
        const values = data.map(item => Number(item[column.property]));
        const sum = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[index] = '₹ ' + this.formatNumber(sum);
      } else if (column.property === 'noOfDaysStock') {
        const totalBranchValue = data.reduce((acc, curr) => acc + (Number(curr.branchTotalValue) || 0), 0);
        const totalAvgSales = data.reduce((acc, curr) => acc + (Number(curr.avgMonthlySales) || 0), 0);
        const finalDays = totalAvgSales > 0 ? totalBranchValue / totalAvgSales * 30 : 0;
        sums[index] = String(Math.round(finalDays));
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  getUnitSummary(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.property === 'unitTotalValue' || column.property === 'unitTotal90PlusValue') {
        const values = data.map(item => Number(item[column.property]));
        const sum = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[index] = '₹ ' + this.formatNumber(sum);
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  getProductSummary(param) {
    const {
      columns
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.property === 'value') {
        const sum = this.filteredProducts.reduce((acc, p) => acc + (p.value || 0), 0);
        sums[index] = '₹ ' + this.formatNumber(sum);
      } else if (['stock', 'slab30', 'slab45', 'slab60', 'slab90', 'slab120', 'slabAbove'].includes(column.property)) {
        const sum = this.filteredProducts.reduce((acc, p) => acc + (Number(p[column.property]) || 0), 0);
        sums[index] = String(sum);
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  async fetchRanges() {
    try {
      this.rangeList = await getRanges(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (err) {
      console.error(err);
    }
  }
  async fetchCategories() {
    if (this.selectedRangeId) {
      try {
        this.categoryList = await getCategories(getQuery({
          enabled: true,
          parentId: true,
          rangeId: this.selectedRangeId,
          sort: 'name,ASC',
          filter: {
            enabled: '$eq',
            parentId: '$isnull',
            rangeId: '$eq'
          }
        }));
      } catch (err) {
        console.error(err);
      }
      if (this.categoryList.length === 0) {
        this.selectedCategoryId = null;
      }
    } else {
      this.categoryList = [];
    }
  }
  async fetchSubCategories() {
    if (this.selectedCategoryId) {
      try {
        this.subCategoryList = await getCategories(getQuery({
          enabled: true,
          parentId: this.selectedCategoryId,
          rangeId: this.selectedRangeId,
          sort: 'name,ASC',
          filter: {
            enabled: '$eq',
            parentId: '$eq',
            rangeId: '$eq'
          }
        }));
      } catch (err) {
        console.error(err);
      }
      if (this.subCategoryList.length === 0) {
        this.selectedSubCategoryId = null;
      }
    } else {
      this.subCategoryList = [];
    }
  }
  handleRangeFilter() {
    this.selectedCategoryId = null;
    this.selectedSubCategoryId = null;
    this.categoryList = [];
    this.subCategoryList = [];
    this.fetchCategories();
    this.refreshCurrentView();
  }
  handleCategoryFilter() {
    this.selectedSubCategoryId = null;
    this.subCategoryList = [];
    if (this.selectedCategoryId) {
      this.fetchSubCategories();
    }
    this.refreshCurrentView();
  }
  handleSubCategoryFilter() {
    this.refreshCurrentView();
  }
  async refreshCurrentView() {
    if (this.currentView === 'branches') {
      await this.fetchData();
    } else if (this.currentView === 'units' && this.selectedBranch) {
      await this.selectBranch(this.selectedBranch);
    } else if (this.currentView === 'products' && this.selectedUnit) {
      await this.selectUnit(this.selectedUnit);
    }
  }
  // Export excel
  exportExcel() {
    let tHeader = [];
    let filterVal = [];
    let data = [];
    let filename = 'stock-value-report';
    if (this.currentView === 'branches') {
      tHeader = ['Branch Name', 'Branch Code', 'Total Stock Value', '90+ Days Value', 'No. of days stock'];
      filterVal = ['branch', 'branchCode', 'branchTotalValue', 'branchTotal90PlusValue', 'noOfDaysStock'];
      data = this.reportData;
      filename = 'branches-stock-value';
    } else if (this.currentView === 'units' && this.selectedBranch) {
      tHeader = ['Unit Name', 'Unit Stock Value', '90+ Days Value'];
      filterVal = ['unit', 'unitTotalValue', 'unitTotal90PlusValue'];
      data = this.unitsList;
      filename = `${this.selectedBranch.branch}-units-stock-value`;
    } else if (this.currentView === 'products' && this.selectedUnit) {
      tHeader = ['Product Id', 'Product', 'Variation Id', 'Variation', 'Stock', '0-30 days', '31-45 days', '46-60 days', '61-90 days', '91-120 days', '120+ days', 'MRP', 'Rate', 'Value'];
      filterVal = ['productId', 'productName', 'productsVariationId', 'variationName', 'stock', 'slab30', 'slab45', 'slab60', 'slab90', 'slab120', 'slabAbove', 'mrp', 'productRate', 'value'];
      data = this.filteredProducts.map(p => ({
        ...p,
        productId: String(p.productId),
        productsVariationId: p.productsVariationId ? String(p.productsVariationId) : '',
        productRate: p.rate
      }));
      filename = `${this.selectedUnit.unit}-products-stock-value`;
    }
    const exportedData = formatJson(filterVal, data);
    exportJson2Excel(tHeader, exportedData, filename);
  }
};
StockValueReport = __decorate([Component({
  name: 'StockValueReport',
  components: {
    Pagination
  }
})], StockValueReport);
export default StockValueReport;